import { modifyState } from '~src/state';
import {
  showSidebarTab,
  handleTabAttachments,
  hideAllSidebarTabs,
} from '~src/sidebarLegacy';

export const magicFrameChangePersonPhoto = () => {
  modifyState('magicFrameSelectPersonPhotoActive', true);
  handleTabAttachments();
  hideAllSidebarTabs();
  showSidebarTab('allegati');
};
